import { Component, OnInit } from "@angular/core";
import { Config } from "src/app/_config/config";
import { FormGroup, FormBuilder } from "@angular/forms";
import { DataService } from "../_service/data.service";
import { ExcelService } from "../_service/excel.service";
import { environment } from "src/environments/environment";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import __ from "underscore";
import { ThrowStmt } from "@angular/compiler";
import { HttpClient } from "@angular/common/http";
import * as column from "./columnList.json";
import * as modelImageList from "./modeImagelList.json";
import { FilterBaseComponent } from '../_base/filter-base.component';
declare const Highcharts: any;
declare const $: any;
declare const moment: any;

@Component({
  selector: "app-hyper-local-lead",
  templateUrl: "./hyper-local-lead.component.html",
  styleUrls: ["./hyper-local-lead.component.scss"],
})
export class HyperLocalLeadComponent extends FilterBaseComponent implements OnInit {
  public config: any = new Config();
  protected filterForm: FormGroup;
  public start_date: any = moment().subtract("days", 30);
  public end_date: any = moment();
  public regionQualification: any = [];
  public outletQualification: any = [];
  public zoneQualification: any = [];
  public allIndaiQualification: any = [];
  public topModel: any = [];
  public modelImage: any = [];


  public imageUrl: string = environment.imageUrl;
  totalLeads: any = { total: 0, qualified: 0, sales: 0, new: 0 };
  loginData: any;
  firstTimeRun: Boolean = true;


  constructor(
  private http: HttpClient,
  private fb: FormBuilder,
  protected dataService: DataService,
  private ExcelService: ExcelService
) {
  super(dataService);

  this.filterForm = this.fb.group({
    zone: [""],
    region: [""],
    parent_group: [""],
    outlet: [""],
    start_date: [this.start_date.format("YYYY-MM-DD")],
    end_date: [this.end_date.format("YYYY-MM-DD")],
    userType: [""],
  });

  this.getLeadHistory();
}

  ngOnInit() {
    this.loginData = this.dataService.getCookies("loginData")
      ? JSON.parse(this.dataService.getCookies("loginData")).acl
      : JSON.parse(localStorage.getItem("loginData")).acl;

    // console.log("this.loginData", this.loginData);
    if (this.loginData.userType === 6) {
      // TSM/RO
      this.parentStatus = true;
      this.getAllParent("aa");
    } else if (this.loginData.userType === 8) {
      // Zonal
      this.regionStatus = true;
      this.parentStatus = true;
      this.getAllRegion("aa");
    } else if (this.loginData.userType === 1) {
      // Agency or HO
      this.regionStatus = true;
      this.parentStatus = true;
      this.zoneStatus = true;
      this.channelStatus = true;
      this.getAllZone();
    } else if (this.loginData.userType === 7) {
      // Agency or HO
      this.regionStatus = true;
      this.parentStatus = true;
      this.zoneStatus = true;
      this.channelStatus = true;
      this.getAllZone();
    } else if (this.loginData.userType === 9) {
      this.parentStatus = true;
      this.outletStatus = true;
      this.channelStatus = true;
      this.getAllChannel("''");
    } else if (this.loginData.userType === 10) {
      // Zonal manager
      this.regionStatus = true;
      this.parentStatus = true;
      // this.zoneStatus = true;
      this.channelStatus = true;
      this.getAllRegion("aa");
    } else {
      this.regionStatus = true;
      this.outletStatus = true;
      this.channelStatus = true;
      this.getAllRegion("''");
    }

    this.filterForm.patchValue({
      userType: this.loginData.userType,
    });
   this.initializeDateRangePicker();
    this.zoneSetting();
    this.regionSetting();
    this.parentSetting();
    this.outletSetting();
    this.columnSetting();
    this.channelSetting();
    this.outletTypeSetting();
    // this.getAllZone();
    this.getLoggedInUserWiseColumnList();
    console.log("this.columnList = ", this.columnList);
  }

get isFilterApplied(): boolean {
  return (
    this.selectedZone.length > 0 ||
    this.selectedRegion.length > 0 ||
    this.selectedParent.length > 0 ||
    this.selectedOutlet.length > 0 ||
    this.selectedChannel.length > 0 ||
    this.selectedOutletType.length > 0 ||
    !this.isDefaultDateRange()
  );
}
  public advanceFilter() {
    if (this.firstTimeRun) {
      this.apiReq = {
        zone: "",
        region: "",
        parent: "",
        outlet: "",
        channel: "",
        outletType: "",
        agl_flag: "",
      };
    }
    this.sourceChart("ww");
    this.getTotalLeads();
    this.getLeadTypeCount();
    this.getLeadSourceCount();
    this.getLeadRegionCount();
    this.getLeadOutletCount();
    this.getLeadZoneCount();
    this.getAllIndia();
    this.getTopModelCount();
    this.getLeadHistory();
    this.getLoggedInUserWiseColumnList();
    console.log("this.columnList = ", this.columnList);

    // this.getAllColumn('hyperlocal_lead_report')
    this.firstTimeRun = false;
  }

  download() {
  if (this.selectedColumn.length === 0) {
    this.dataService.showError("Please select column name.");
    return;
  }

  this.dataService.startLoader();

  // ← buildFinalData() is missing columnList and userEmail
  // build a custom payload that extends buildFinalData()
  const finalData = {
    ...this.buildFinalData(),
    userEmail: this.loginData.userEmail,
    columnList: this.selectedColumn,
  };

  this.dataService.post("hyperlocal/downloadHyperlocal", finalData).subscribe(
    (res) => {
      this.dataService.stopLoader();
      if (res["code"] == 200) {
        if (res["data"].length) {
          this.ExcelService.exportAsExcelFile(res["data"], "hyper_lead_report");
        } else {
          this.dataService.showError("No Data Found.");
        }
      } else {
        this.dataService.showError(res["message"]);
        if (res["code"] == 401) {
          this.dataService.logout();
        }
      }
    },
    (err) => {
      this.dataService.stopLoader();
    }
  );
}
  // listenForUpdates(jobId: string) {
  //   const eventSource = new EventSource(
  //     `${environment.localBaseUrl}hyperlocal/report-status/${jobId}`
  //   );

  //   eventSource.onmessage = (event) => {
  //     const status = JSON.parse(event.data);

  //     if (status.status === "completed") {
  //       eventSource.close();
  //       if (status.data.length) {
  //         this.ExcelService.exportAsExcelFile(
  //           status["data"],
  //           "hyper_lead_report"
  //         );
  //         this.dataService.showSuccess(`Excel File Downloaded`);
  //       } else {
  //         this.dataService.showError("No Data Found.");
  //       }
  //     } else if (status.status === "failed") {
  //       eventSource.close();
  //       this.dataService.showError("Report generation failed.");
  //     }
  //   };

  //   eventSource.onerror = (err) => {
  //     console.error("EventSource failed:", err);
  //     eventSource.close();
  //   };
  // }

  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

 public clearFilter() {
  this.dataService.removeCookies("hyperLocalFilter", "");
  this.selectedZone = [];
  this.selectedRegion = [];
  this.selectedParent = [];
  this.selectedChannel = [];
  this.selectedOutlet = [];
  this.selectedOutletType = [];
  window.location.reload();
}


  public changeValue(event, type) {
    let value = event.target.value;
    if (type == "zone") {
      this.filterForm.controls["region"].setValue("");
      this.regionList = value
        ? __.where(this.config.regionList, { ZONE: value })
        : this.config.regionList;
    } else if (type == "region") {
    }
  }

  public getTotalLeads() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/totalLeads", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          // console.log("res", res);
          this.totalLeads = res["data"];
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getLeadTypeCount() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getLeadTypeCount", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.leadTypeChart(res["data"]);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getLeadHistory() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getLeadHistory", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          // console.log("getLeadHistory", res);
          this.leadHistoryChart(res["data"]);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getLeadSourceCount() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getLeadSourceCount", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.sourceChart(res["data"]);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getLeadRegionCount() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getLeadRegionCount", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.regionQualification = res["data"];
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getLeadOutletCount() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getLeadOutletCount", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.outletQualification = res["data"];
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getLeadZoneCount() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getLeadZoneCount", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.zoneQualification = res["data"];
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllIndia() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService
      .post("hyperlocal/getAllIndiaQualification", finalData)
      .subscribe(
        (res) => {
          this.dataService.stopLoader();
          if (res["code"] == 200) {
            this.allIndaiQualification = res["data"];
          } else {
            this.dataService.showError(res["message"]);
            if (res["code"] == 401) {
              this.dataService.logout();
            }
          }
        },
        (err) => {
          this.dataService.stopLoader();
          // this.dataService.showError(err['message']);
        }
      );
  }
  public getZoneName(zone) {
    for (let i = 0; i < this.config.zoneList.length; i++) {
      if (this.config.zoneList[i].CODE == zone) {
        zone = this.config.zoneList[i].DESC;
        break;
      }
    }
    return zone;
  }

  public getTopModelCount() {
    this.dataService.startLoader();
    const finalData = this.buildFinalData();
    this.dataService.post("hyperlocal/getTopModelCount", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          // console.log("getTopModelCount", res);
          this.topModel = res["data"];

          this.modelImage = modelImageList['default'];
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public leadTypeChart(leadType) {
    Highcharts.chart("leadType_chart", {
      chart: {
        type: "bar",
        height: 380,
      },
      exporting: { enabled: false },
      title: { text: "" },
      subtitle: { text: "" },

      xAxis: {
        categories: [""],
        title: { text: null },
      },

      yAxis: {
        type: 'logarithmic', 
        minorTickInterval: 0.1,
        title: {
          text: "Leads",
          align: "high",
        },
        labels: { overflow: "justify" },
      },

      tooltip: {
        valueSuffix: " Leads",
      },

      plotOptions: {
        series: {
          events: {
            legendItemClick: function () {
              const clicked = this;
              const chart = this.chart;

              const visibleSeries = chart.series.filter(s => s.visible);

              // If clicked series is already the only one visible → show all
              if (visibleSeries.length === 1 && visibleSeries[0] === clicked) {
                chart.series.forEach(s => s.setVisible(true, false));
                chart.redraw();
                return false;
              }

              // Otherwise → show only clicked series
              chart.series.forEach(s => {
                s.setVisible(s === clicked, false);
              });
              chart.redraw();

              return false;
            },
          },
        },

        bar: {
          minPointLength: 3, 
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            inside: false,
            overflow: "allow",
            crop: false,
            style: {
              fontSize: "9px",
              textOutline: "none"
            }
          },
        },
      },

      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
        x: 10,
        y: -10,
        floating: false,
        borderWidth: 1,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
        shadow: true,
      },

      credits: { enabled: false },
      series: leadType,
    });
  }


  public leadHistoryChart(leadHistory) {
    // lead history chart
    // console.log(leadHistory);
    Highcharts.chart("leadHistory_chart", {
      chart: {
        type: "column",
      },
      exporting: { enabled: false },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        type: "category",
      },
      yAxis: {
        title: {
          text: "",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y}",
          },
        },
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>',
      },

      series: [
        {
          name: "",
          colorByPoint: true,
          data: leadHistory,
        },
      ],
    });
  }

  public sourceChart(leadSource) {
    Highcharts.chart("source_chart", {
      chart: {
        type: "bar",
        height: 380,
      },
      exporting: { enabled: false },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        categories: [""],
        title: {
          text: null,
        },
      },
      yAxis: {
        type: 'logarithmic', 
        minorTickInterval: 0.1,
        title: {
          text: "Leads",
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
      },
      tooltip: {
        valueSuffix: " Leads",
      },
      plotOptions: {
        bar: {
          minPointLength: 3,
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            inside: false,
            overflow: "allow",
            crop: false,
            style: {
              fontSize: "9px",
              textOutline: "none"
            }
          },
        },
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
        x: 10,
        y: -10,
        floating: false,
        borderWidth: 1,
        width: 170,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
        shadow: true,
      },
      credits: {
        enabled: false,
      },
      series: leadSource,
    });
  }


  similarity(a: string, b: string): number {
    const longer = a.length > b.length ? a : b;
    const shorter = a.length > b.length ? b : a;

    const longerLength = longer.length;

    if (longerLength === 0) return 1.0;

    return (longerLength - this.editDistance(longer, shorter)) / longerLength;
  }

  editDistance(a: string, b: string): number {
    const matrix = [];

    for (let i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }

    for (let j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }


  normalizeKey(value: string) {
    return value
      .toLowerCase()
      .replace(/new/g, '')       // remove "new"
      .replace(/-/g, ' ')        // convert "-" to space
      .replace(/_/g, ' ')        // convert "_" to space
      .replace(/\s+/g, ' ')      // normalize spaces
      .trim();
  }

  getImage(modelName: string): string {
    // if (!modelName) {
    return 'assets/images/Icon.png';
    // }

    // const keyArray = modelName.toLowerCase().split(' ');

    // const list = modelImageList['default'];

    // let bestMatch: string | null = null;

    // for (const itemKey of Object.keys(list)) {
    //   const lowerKey = itemKey.toLowerCase();

    //   // Exact word match
    //   if (keyArray.includes(lowerKey)) {
    //     bestMatch = itemKey;
    //     break; // exact match is good enough
    //   }
    // }

    // if (bestMatch) {
    //   return list[bestMatch];
    // }

    // return 'assets/images/Icon.png';
  }

  getLoggedInUserWiseColumnList() {
    console.log("user_role = ", this.loginData.user_role);
    const columnData = column["default"];
    if (this.loginData && this.loginData.user_role && ['214', '224'].includes(this.loginData.user_role)) { // for dealer login
      this.columnList = columnData["business_unit_id"];
    } else if (this.loginData && this.loginData.user_role && ['216', '220', '221', '222', '225'].includes(this.loginData.user_role)) { // for RO and Zonel login
      this.columnList = columnData["region"];
    } else if (this.loginData && this.loginData.user_role && ['1', '2', '3'].includes(this.loginData.user_role)) { // for admin, agency and digm login
      this.columnList = columnData["default"];
    } else { // for other login
      this.columnList = columnData["old_columns"];
    }
  }

  

}